import React from 'react';
import { injectIntl } from 'react-intl';
import { i18nIntl, isDesktop } from '../../lib/ep.js';
import md5 from 'md5';

import ShareButton from './buttons/ShareButton.js';

const ShareGameFinal = ({ stage, promotion, ...props }) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const is_builder = props?.is_builder ?? false;

	const locale = (props.locale != undefined) ? `?lc=${props.locale}` : '';
	const result = props?.result ?? false;
	const participation_hash = md5(`${result.uid}EPTEAM`).slice(0, 6);
	const participation_id = result.uid ?? (result.id ?? 'test');

	const base_url = (!is_builder && window.domain_url) ? `https://${window.domain_url}` : window.public_url
	const share_url_base = (base_url) ? `${base_url}` : `https://${window.location.host}`;

	const share_title = stage?.share_title ?? i18n("This is my photo");
	const share_description = stage?.share_description ?? i18n("You can create your own!");
	const share_tweet = stage?.share_tweet ?? (promotion?.post_tweet ?? share_title);
	const share_instant = stage?.share_instant ?? (promotion?.post_instant ?? share_title);

	const image = result?.team_image ?? false;

	const share_layer_props = {
		is_builder,
		promotion,
		info:{
			url:`${share_url_base}/share/${participation_id}/${participation_hash}${locale}`,
			image:image,
			title:share_title,
			descriptionenc:share_description,
			postenc:encodeURI(share_tweet),
			instantenc:encodeURI(share_instant),
			urlencodeparameter:'',
		},
		is_mobile:!isDesktop(),
		enable_behavior:(is_builder) ? true : null,
		layer_title:i18n(props?.layer_title ?? "Share your photo"),
		sharing_type:'photofun',
		sharing_page:'photofun',
	};

	if(is_builder) {
		return (
			<ShareButton
				{...share_layer_props}
				icon={false}
				{...props.custom_cta_props}
				is_builder={true}
				custom_onClick={() => { alert(i18n("This will open the Share dialog")); }}
			>{stage?.button_label ?? i18n("Share")}</ShareButton>
		)
	}

	return (
		<ShareButton
			{...share_layer_props}
			icon={false}
			onOpenLayer={props.onOpenLayer}
			{...props.custom_cta_props}
		>{stage?.button_label ?? i18n("Share")}</ShareButton>
	)
};

export default injectIntl(ShareGameFinal);